import axios from '_u/axios'

// 租客列表
export const tenantsList = (body) => {
    return axios.post('api/contract/cus/list', body)
}

// 解除绑定
export const tenantsUnBind = (id) => {
    return axios.post('api/customer/info/unBind', { id })
}

export const notifyList = (body) => {
    return axios.post('api/notify/msg/list', body)
}

// 提醒页面
export const billDetails = (body) => {
    return axios.post('api/contract/cus/billDetails', body)
}

// 根据账期获取收据
export const queryReceipt = (body) => {
    return axios.post('api/contract/cus/queryReceipt', body)
}

// 发送提醒
export const sendRemind = (body) => {
    return axios.post('api/contract/cus/send', body)
}

// 手机号绑定
export const bindByPhone = (body) => {
    return axios.post('api/contract/cus/bindByPhone', body)
}
